export default __webpack_public_path__ + "static/media/background.f10d552b.jpg";